import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Overview from "./components/Overview";
import Emergencies from "./components/Emergencies";
import LostFound from "./components/LostFound";
import LiveUpdates from "./components/LiveUpdates";
import ViewUpdates from "./components/ViewUpdates";
import "./styles/styles.css";
import { ToastContainer } from "react-toastify";
import AddPoints from "./components/AddPoints";
import Feedbacks from "./components/Feedbacks";
import PointsInsights from "./components/PointsInsights";
import CrowdInsights from "./components/CrowdInsights";
import Reports from "./components/Reports";

const App = () => {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Overview />} />
          <Route path="/emergencies" element={<Emergencies />} />
          <Route path="/lost-found" element={<LostFound />} />
          <Route path="/live-updates" element={<LiveUpdates />} />
          <Route path="/add-points" element={<AddPoints />} />
          <Route path="/view-updates" element={<ViewUpdates />} />
          <Route path="/feedbacks" element={<Feedbacks />} />
          <Route path="/points-insight" element={<PointsInsights />} />
          <Route path="/crowd-insights" element={<CrowdInsights />} />
          <Route path="/reports" element={<Reports />} />
        </Routes>
      </Router>
      <ToastContainer toastStyle={{ zIndex: 9999 }} />
    </div>
  );
};

export default App;
